import React from 'react';
import PropTypes from 'prop-types';
import InfoTooltip from '../../../compat/InfoTooltip';

/**
 * ComparisonOverlay.
 * Overlay for product comparison table tooltips.
 *
 * @author  Manny
 * @param   {String}      props.tooltip         Tooltip text to display.
 * @returns {JSX.Element} The component markup.
 */

const ComparisonOverlay = ({ tooltip }) => {
  return (
    <InfoTooltip text={tooltip}>
      <span>
        <i className='far fa-question-circle tooltip-icon' aria-hidden='true'></i>
      </span>
    </InfoTooltip>
  )
}

ComparisonOverlay.propTypes = {
  tooltip: PropTypes.string.isRequired,
};

export default ComparisonOverlay;
